import React, { Component } from 'react';
import { DefaultRequest } from '../requests/default.request';
import { EmptyDataNode } from './empty-data-node.component';
import _ from 'lodash';
import { Button, Input } from '@material-ui/core';
import { WebsocketClient } from '../websocket/module';

// Message Modal
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from "../messenger/module";
import i18n from '../i18n';
import { getCacheField } from '../tools/get-cache-field';
import BounceSpace from './bounce-space.component';
import { PHONE_TYPE } from '../tools/utils';
import { FixedCartData } from '../pages/order-cart';
import ServerShoppingCart from '../modules/server-shopping-cart';

export class Condiments extends Component<RetreatProps, State>{
    public messengerModule: MessengerModule;
    constructor(props: RetreatProps) {
        super(props);
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
        this.state = {
            // 调味品
            menuCondiments: [],
            // 调味品详情
            condimentsDetail: [],
            // 调味品详情相对应的id
            condimentSelectedID: 0,
            // 调味品info
            condimentsInfo: [],
            // 顾客
            customers: getCacheField('orderTab.customer'),
            // 暂位块级
            flag: false
        };
    }

    // 调味品备注
    public remark = '';

    public UNSAFE_componentWillMount() {
        const { dish } = this.props;
        // console.log(dish)
        this.remark = dish.remark || '';
        this.setState({
            condimentsDetail: _.cloneDeep(dish.condiments),
        })
        this.getCondiments()
        const findRes = this.getSettingInfoValue('show-item-name1-or-item-name2')
        if (findRes) this.isShowName1 = findRes.value.showItemName1
    }
    public componentDidMount() {
        // $ 即将进入下一轮( x秒 ) , 取消菜品的编辑操作
        WebsocketClient.addListener('CANCLE_DISH_EDIT', this.cancelDishEditListener)
    }
    public componentWillUnmount() {
        WebsocketClient.removeListener('CANCLE_DISH_EDIT', this.cancelDishEditListener)
    }

    // 显示item_name1或item_name2
    public isShowName1 = true;
    public getSettingInfoValue(str: string) {
        const SETTING = getCacheField('settingInfo');
        return _.find(SETTING, ['name', str]);
    }

    // $ 监听取消菜品的编辑操作
    public cancelDishEditListener = () => {
        this.onClose(this.props.dish)
    }

    /**
     * 获取调味品
     */
    public async getCondiments() {
        let CONDIMENTS = await DefaultRequest.getCondiments();
        // 对接可选调味品
        const selectCondimentGroup = this.props.dish?.selectCondimentGroup || -1;
        if (selectCondimentGroup > 0) {
            const group = CONDIMENTS.find(item => item.scomdiment_groups_id === selectCondimentGroup);
            CONDIMENTS = group ? [group] : [];
        }
        this.setState({
            menuCondiments: CONDIMENTS,
            condimentSelectedID: CONDIMENTS.length ? CONDIMENTS[0].scomdiment_groups_id : 0
        })
    }

    public isSelected(id: string) {
        for (let value of this.state.condimentsDetail) {
            if (`${value.item_id}` === id || `${value.originId}` === id) {
                return true;
            }
        }
        return;
    }

    /**
     * 缓存调味品并绑定购物车
     */
    public cacheCondiments() {
        // const { dish, customers } = this.props
        const { condimentsDetail } = this.state

        // ShoppingCart.updateDishCondimentsAndRemarksInCart(
        //     ShoppingCart.globalRound,
        //     customers,
        //     condimentsDetail,
        //     this.remark,
        //     dish._origin
        // )

        const { dish } = this.props

        // 服务端购物车 编辑调味品
        ServerShoppingCart.updateServerCart({
            dish: {
                ...dish,
                condiments: condimentsDetail,
                remark: this.remark
            },
            action: { type: 1, state: 1, nonQuantity: true },
            isAddedToCart: true,
        })

    }

    public getArray<T>(value: any, isNewPoint = false): Array<T> {
        let t;
        if (isNewPoint) {
            t = _.cloneDeep(value);
        } else {
            t = value;
        }
        return Array.isArray(t) ? t : [];
    }


    // $ 关闭弹窗
    public onClose(dish: RetreatProps['dish']) {
        this.props.updateLocalState({
            condimentModel: false
        })
    }

    public render() {
        const { dish } = this.props
        const { menuCondiments, condimentSelectedID } = this.state
        return (
            <div className='condimentsContainer'>
                {/* 主体范围 */}
                <div className={this.state.flag ? 'condimentsMainBody-flag' : 'condimentsMainBody'}>
                    <div className='conndimentsTopView'>
                        {/* on close */}
                        <div className='onCloseCondim' >
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ color: '#00CCCC' }}>{dish.originId}</div>
                                <div style={{ color: '#fff', fontSize: 28 }} onClick={() => {
                                    this.onClose(dish);
                                    this.setState({ flag: false });
                                }}> × </div>
                            </div>

                            <div className='itemName'>{
                                //  改成name1 name2
                                this.isShowName1 ? dish.name : dish.name2
                            } </div>
                        </div>
                        {/* Codiment Option / 调味品卡片 */}
                        <div className='card'>
                            {
                                !this.getArray(menuCondiments).length ? <EmptyDataNode /> :
                                    <div className='condimentsCard'>
                                        {
                                            menuCondiments.map((item, index) => {
                                                return (
                                                    <Button
                                                        className='cardBtn'
                                                        style={
                                                            item.scomdiment_groups_id === condimentSelectedID ? {
                                                                minWidth: 100,
                                                                height: 55,
                                                                backgroundColor: '#28508A',
                                                                boxShadow: '1px 2px 5px -1px #ffffff6b'
                                                            } : {}}
                                                        key={index}
                                                        onClick={() => {
                                                            this.setState({
                                                                condimentSelectedID: item.scomdiment_groups_id,
                                                            })
                                                        }}>{item.comdiment_groups_name}</Button>
                                                )
                                            })
                                        }
                                    </div>
                            }
                        </div>
                        {/* 调味品详情 */}
                        <div className='condimentsDetail'>
                            {
                                (() => {
                                    for (let value of menuCondiments) {

                                        if (value.scomdiment_groups_id === condimentSelectedID) {

                                            return value.comdiments.map((item: any, index: number) => {
                                                if (item.item_name1) {
                                                    return (
                                                        <Button
                                                            style={this.isSelected(`${item.item_id || item.originId}`) ? {
                                                                backgroundColor: '#28508A',
                                                                boxShadow: '1px 2px 8px -1px #ffffff6b'
                                                            } : {}}
                                                            size='small'
                                                            className='cardDetailBtn'
                                                            key={index}
                                                            onClick={() => {
                                                                /**
                                                                 *  check select CondimentsDish
                                                                 */
                                                                let condimentsDetail = _.cloneDeep(this.state.condimentsDetail);
                                                                this.isSelected(`${item.originId || item.item_id}`)
                                                                    ?
                                                                    _.remove(condimentsDetail, (v) => {
                                                                        return `${v.item_id || v.originId}` === `${item.item_id || item.originId}`;
                                                                    })
                                                                    : condimentsDetail.push(Object.assign(item, {
                                                                        scomdiment_groups_id: condimentSelectedID,
                                                                        free: item.price_1 > 0 ? false : true
                                                                    }));

                                                                this.setState({ condimentsDetail });
                                                            }}>{item.item_name1}</Button>
                                                    )
                                                }
                                                return null;
                                            })
                                        }
                                    }
                                })()
                            }
                        </div>
                    </div>
                    <div className='conndimentsBottomView'>

                        {/* 调味品备注 */}
                        <div className='condimentsRemark'>
                            <div className='titRemark'>{i18n.t('order_cart_page_text_dish_remarks')}</div>
                            <div>
                                <Input
                                    defaultValue={this.remark}
                                    rows={4}
                                    multiline
                                    disableUnderline
                                    fullWidth
                                    onChange={(event) => { this.remark = event.target.value }}
                                    onFocus={() => {
                                        if (PHONE_TYPE.indexOf('Android') > -1 || PHONE_TYPE.indexOf('Linux') > -1) {
                                            this.setState({ flag: true });
                                        };
                                    }}
                                    onBlur={() => {
                                        this.setState({ flag: false });
                                    }}
                                />
                            </div>
                        </div>
                        {/* 确认按钮 */}
                        <div className='condimentsDone'>
                            <Button

                                onClick={() => {
                                    try {
                                        this.setState({ flag: false });


                                        this.cacheCondiments();
                                        this.state.condimentsDetail.forEach((val: any) => {
                                            this.state.condimentsInfo.push(val.item_name1)
                                        })

                                        // dish.condiments = this.state.condimentsDetail;
                                        // dish.remark = this.remark;
                                        this.props.updateLocalState({
                                            condimentModel: false,
                                            condimentsInfo: this.state.condimentsInfo.toString()
                                        })
                                        // WebsocketClient.emitOrderClients({
                                        //     event: 'UPDATE_CONDIMENTS',
                                        //     customer: this.props.customers,
                                        //     dishes: dish,
                                        //     wid: dish._id,
                                        //     cartData: ShoppingCart.metaData
                                        // })

                                        // Store.dispatch({
                                        //     type: 'SET_CACHING',
                                        //     path: 'shoppingCart',
                                        //     value: ShoppingCart.metaData
                                        // })
                                    } catch (error) {
                                        this.messengerModule.say({
                                            level: 'Warning',
                                            message: `${i18n.t('general_text_update_faild')}`,
                                        })
                                    }
                                }}
                                style={{
                                    backgroundColor: '#FF8873',
                                    width: '40%',
                                    minHeight: '5.5vh',
                                    borderRadius: 5
                                }}
                            >{i18n.t('general_button_done')}</Button>
                        </div>
                    </div>
                </div>
                {this.state.flag &&
                    <BounceSpace
                        params={
                            {
                                isShowBounce: this.state.flag,
                                className: 'bounceSpace',
                            }
                        } />}
            </div >
        );
    }
}

export default withSnackbar(Condiments);
// *********************
// Styles
// *********************

type RetreatProps = {
    updateLocalState: (val: any) => void
    dish: FixedCartData,
    customers: string
    turnRound: null | string
    customerArr: string[]
    roundArr: string[]
} & WithSnackbarProps;
type State = {
    menuCondiments: Array<any>
    condimentsDetail: Array<any>
    condimentSelectedID: number
    customers: string
    condimentsInfo: Array<any>
    flag: boolean
};
